/** Tooltip copy for both-mode NEX lookup metadata in Key Identifiers. */
export function formatBothModeNexLookupTooltip(args: {
    matchedVia?: 'po' | 'ro' | null;
    matchedCandidate?: string | null;
    shopRoNumber?: string | null;
}): string | null {
    const via = args.matchedVia;
    const candidate = String(args.matchedCandidate ?? '').trim();
    if (!via || !candidate) return null;
    const ro = String(args.shopRoNumber ?? '').trim();
    if (via === 'po') {
        return ro
            ? `Nexsyis lookup used PO ${candidate} to resolve repair order ${ro}. Line items are matched from the repair-order endpoint.`
            : `Nexsyis lookup used PO ${candidate}. Line items are matched from the repair-order endpoint.`;
    }
    return `Nexsyis lookup used repair order ${candidate}. Line items are matched from the repair-order endpoint.`;
}
